export default __webpack_public_path__ + "static/sadewa-d4ef89e12a66785c9cf5785b827d97d3.png";